module.exports = __webpack_public_path__ + "static/media/img38.0aac70f1.jpg";